import React from 'react'

export default function ButtonSubmit({ loading, labeling, label, disabled }) {
  return (
    <div>
        <button type='submit' disabled={disabled}
            className="w-full bg-orange-400 text-white py-2 px-4 rounded-lg duration-300 hover:scale-103"
        >
            {loading ? labeling : label}
        </button>
    </div>
  )
}
